import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media, mediaQuery } from '../../common/styles/styleUtil';

interface TagsWrapperProps {
  isOnProjectPage: boolean;
}
export const TagsWrapper = styled.ul<TagsWrapperProps>`
  width: 100%;
  padding: 0;
  margin-bottom: 12px;
  ${media.xs`
    padding: 0 16px;
  `}
  ${ifProp(
    { isOnProjectPage: true },
    css`
      @media (${mediaQuery.tablet}) {
        padding: 0 24px;
      }
      ${media.xs`
        padding: 0 16px;
      `}
    `,
  )}
`;

export const TagsItem = styled.li`
  display: inline-block;
  margin: 0;
  padding: 0 4px 12px 0;

  a {
    display: block;
    color: #697684;
    font-size: 14px;
    font-weight: 300;
    border-radius: 8px;
    border: solid 1px #697684;
    background-color: #ffffff;
    line-height: 14px;
    padding: 5px 8px;
    &:hover {
      background: #f7f8f9;
      color: #697684;
    }
  }
`;
